import { Component, DestroyRef, inject, Input } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import {
  heroBars3BottomLeft,
  heroBell,
  heroPhoto,
  heroPlus,
  heroSquare3Stack3d,
  heroUsers,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { AuthService } from 'app/auth/auth.service';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { AvatarContainerComponent } from 'app/shared/avatar/avatar-container/avatar-container.component';
import { TitleComponent } from 'app/shared/title/title.component';
import { AddStoryComponent } from 'app/my-history/story/add-story/add-story.component';
import { routePath } from 'app/shared/app.config';
import { GuestHeaderComponent } from '../my-history/guest/guest-header/guest-header.component';
import { NgIf } from '@angular/common';
import { ProfileService } from 'app/profile/profile.service';
import { ProgressComponent } from 'app/profile/progress/progress.component';
import { NotificationsService } from 'app/notifications/notifications.service';
import { NotificationsComponent } from 'app/notifications/notifications.component';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header-layout',
  standalone: true,
  imports: [
    SideMenuComponent,
    IconComponent,
    AvatarContainerComponent,
    TitleComponent,
    RouterLink,
    RouterLinkActive,
    AddStoryComponent,
    GuestHeaderComponent,
    RouterOutlet,
    NgIf,
    ProgressComponent,
    NotificationsComponent,
  ],
  providers: [
    provideIcons({
      heroUsers,
      heroBars3BottomLeft,
      heroSquare3Stack3d,
      heroPhoto,
      heroBell,
      heroPlus,
      heroXMark,
    }),
  ],
  templateUrl: './header-layout.component.html',
  styleUrl: './header-layout.component.scss',
})
export class HeaderLayoutComponent {
  @Input() containerBackground = 'bg-gradient-to-b from-white from-25% to-85% to-gray-lighten';
  user = inject(AuthService).user;
  progress = inject(ProfileService).progress;
  notificationService = inject(NotificationsService);
  router = inject(Router);
  destroyRef = inject(DestroyRef);
  dialogOpened = this.notificationService.dialogOpened;
  protected readonly routePath = routePath;
  total = this.notificationService.total;
  toggleDialog() {
    this.notificationService.toggleDialog();
  }

  constructor() {
    this.notificationService.getUnread();
    this.listenToRouteChanges();
  }

  private listenToRouteChanges() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        if (this.dialogOpened()) {
          this.notificationService.toggleDialog(false);
        }
      });
  }
}
